import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReferralNotesComponent } from './referral-notes.component';

const routes: Routes = [ { path: '', component: ReferralNotesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReferralNotesRoutingModule { }
